<script setup lang="ts">
import _service from "@/service";
import { useAccountStore } from "@/stores/account";
import starImg from "@/assets/integral/star.svg";
import { onMounted, ref, watch } from "vue";
import moment from "moment";
import { List, Tab, Tabs } from "vant";
import { isDev } from "@/utils";
import { useRouter } from "vue-router";
const router = useRouter()
const accountStore = useAccountStore();
const activeTabIndex = ref(0);
const balance = ref("0");
const pageNo = ref(0);
const recordList = ref<any>([]);
const listLoading = ref(false);
const listFinished = ref(false);
const tabList = [
  {
    label: "全部",
    value: "1",
  },
  {
    label: "获取",
    value: "2",
  },
  {
    label: "消耗",
    value: "3",
  },
];

const getRecordList = async () => {
  if (listFinished.value) {
    return false;
  }
  listLoading.value = true;
  let tokenTransfer = "";
  activeTabIndex.value === 1 && (tokenTransfer = "in");
  activeTabIndex.value === 2 && (tokenTransfer = "out");
  const postData = {
    pos: 20,
    offset: pageNo.value,
    tokenTransfer,
    account: accountStore.getUserInfo.name,
    symbol: "STAR",
    contract: import.meta.env.VITE_STAR_CONTRACT,
  };
  const { data } = await _service.getTransferLog(postData);
  listLoading.value = false;
  recordList.value = recordList.value.concat(data);
  if (data.length < 20) {
    listFinished.value = true;
    return false;
  }
  pageNo.value = pageNo.value + 1;
};

const resetList = () => {
  recordList.value = [];
  pageNo.value = 0;
  listFinished.value = false;
};

const getUserBalance = async () => {
  const [_balance]: any = await _service.getBalanceByUser({
    code: "star.token",
    account: accountStore.getUserInfo.name,
    symbol: "STAR",
  });
  balance.value = _balance?.split(' ')[0];
};

const onLoad = () => {
    console.log('onLoad');
    
  getRecordList();
};

watch(()=>activeTabIndex.value,()=>{
    resetList()
})

onMounted(() => {
  getUserBalance();
});
</script>

<template>
  <div class="layout">
    <div class="recordsheader">
      <div class="box">
        <img :src="starImg" alt="" />
        <div>
          <span class="number">{{ balance || 0}}</span>
          STAR
        </div>
      </div>
    </div>
    <div class="recordtab">
      <Tabs v-model:active="activeTabIndex" sticky swipeable>
        <Tab :title="item.label" v-for="item in tabList" :key="item.label">
          <div class="list-wrapper">
            <List
              v-model:loading="listLoading"
              :finished="listFinished"
              @load="onLoad"
            >
              <div class="no-data" v-if="listFinished && !recordList.length">
                暂无数据
              </div>
              <div
                class="listitem flex-row-between-start"
                v-for="item in recordList"
                :key="item.traceId"
                @click="()=>{
                    router.push({ path: '/integral/transactions', state: item })
                }"
              >
                <div class="left">
                  <div class="text">{{ item.transferMemo }}</div>
                  <div class="time">
                    {{
                      moment(item.createTime * 1000).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                    }}
                  </div>
                </div>
                <div class="right">{{item.fromAccount === accountStore.getUserInfo.name ? '-' : '+' }}{{ item.tokenValue }}</div>
              </div>
            </List>
          </div>
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.layout {
  height: 100%;
  min-height: 100vh;
  background: #070b14;
  :deep(.van-tabs__nav) {
    display: flex;
    justify-content: flex-start;
    gap: 30px;
    padding: 0 12px;
    background: transparent;
    .van-tab {
      flex: unset;
      color: #9c9caa;
      text-align: center;
      font-family: "Noto Sans SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .van-tab--active {
      color: #1cf2e4;
      text-align: center;
      font-family: "Noto Sans SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px; /* 150% */
    }
    .van-tabs__line {
      width: 28px;
      bottom: 3px;
      height: 7px;
      background: url(../../../assets/integral/activeTab.svg);
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}
.recordsheader {
  padding: 0 16px;
  padding-top: 14px;
  .box {
    display: flex;
    width: 100%;
    padding: 18px 14px;
    align-items: center;
    gap: 14px;
    border-radius: 12px;
    background: #1f212d;
    color: var(--2, #6efa97);
    font-family: "D-DIN Exp";
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 140% */
    text-transform: capitalize;
    margin-bottom: 14px;
    img {
      width: 44px;
    }
    .number {
      font-family: "D-DINExp";
      font-size: 32px;
      font-style: normal;
      font-weight: 700;
      line-height: 34px; /* 106.25% */
      text-transform: capitalize;
      margin-right: 8px;
      background: linear-gradient(
        111deg,
        #fff853 4.98%,
        #6eef94 56.05%,
        #2ad8cd 95.37%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
.recordtab {
  .tablayout {
    padding: 0 16px;
  }
  .list-wrapper {
    padding: 0 16px;
    height: calc(100vh - 160px);
    overflow-y: scroll;
    .listitem {
      margin: 20px 0;
      .text {
        color: $text1;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
        height: 14px;
      }
      .time {
        color: $text2;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: "D-DIN Exp";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px; /* 116.667% */
        margin-top: 6px;
      }
      .right {
        color: #1cf2e4;
        text-align: right;
        font-family: "D-DIN Exp";
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
    }
  }
}
</style>
